import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import BaseReceiptHeadInfo from './receipt-head-info.base';
import { Title } from './receipt-head-info.styled';
import { IOrderHeaderProps } from './types';

const ReceiptHeadInfo: FC<React.PropsWithChildren<IOrderHeaderProps>> = ({ order }) => {
  const { formatMessage } = useIntl();
  const message = formatMessage({ id: 'orderDetailsHeading' });
  return (
    <>
      <Title accessibilityLabel={message}>{message}</Title>
      <BaseReceiptHeadInfo order={order} />
    </>
  );
};

export default ReceiptHeadInfo;
